import { Component, inject, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { StatefulService } from '@app/service/stateful.service';
import { AuthType, ContactType, PhoneType } from '@shared/enum';
import { LenderConfiguration } from '@shared/model/lender-config.model';
import { LenderService } from '@shared/service/lender/lender.service';
import { CustomModal } from '@workflow/dynamic-render/page/shared/core-custom-page.decorator';
import { UserService } from '@workflow/ecp-shared/service/user/user.service';

@CustomModal('migrated-application')
@Component({
  selector: 'ecp-migrated-application',
  templateUrl: './migrated-application.component.html'
})
export class MigratedApplicationComponent implements OnInit {
  /** Lender Specific Config Data */
  public lenderData: LenderConfiguration;
  public headingMessage = 'Your lender is now handling your application';
  public statefulService = inject(StatefulService);

  constructor(public readonly lenderService: LenderService, private readonly userService: UserService, private readonly router: Router) {}

  ngOnInit(): void {
    this.lenderData = this.lenderService.lenderDataInfo;
  }

  /**
   * Method to get Migrated application contact message
   */
  public get migratedContactMessage() {
    const hasPhoneNumber =
      this.lenderData?.contacts?.length > 0 &&
      this.lenderData?.contacts?.filter((f) => f.type.toString().toLowerCase() === ContactType.Phone.toLowerCase()).length > 0;
    return hasPhoneNumber
      ? 'You can contact them at ' +
          this.lenderData?.contacts?.filter((f) => f.type.toString().toLowerCase() === ContactType.Phone.toLowerCase())[0].value +
          ' for status updates.'
      : 'You can contact us for status updates.';
  }

  /**
   * Method to handle the navigation upon click of navigation button
   */
  public onNavigationButtonClick(): void {
    this.statefulService.wrap('ss:showMigratedApplicationModal').value = false;
    // If User is Authenticated -> navigate to Dashboard, else -> navigate to Login
    if (this.isUserAuthenticated) {
      this.router.navigate(['/consumer/dashboard']);
    } else {
      this.router.navigate(['/user/login'], {
        queryParams: {
          authType:
            this.statefulService.wrap('ola:borrowerInfo/phoneType').valueString.toLowerCase() === PhoneType.Mobile.toLowerCase()
              ? AuthType.Phone
              : AuthType.Email
        }
      });
    }
  }

  /**
   * Method to get navigation button text
   * Returns Exit to Dashboard if User is Authenticated else Login
   */
  public get navigationButtonText() {
    return this.isUserAuthenticated ? 'Exit to Dashboard' : 'Login';
  }

  /**
   * Method to determine if the User is Authenticated or not
   */
  public get isUserAuthenticated() {
    return this.userService?.isAuthenticated;
  }
}
